<div class="gallery-pagination is-flex has-flex-content-center" *ngIf="totalPages > 1">
  <ng-container *ngIf="currentPageNumber >= 1">
    <a class="pagination-item text-center" (click)="changePage(0, $event)" [routerLink]="disableSEO ? null : baseUrl">
      <<
    </a>
    <a class="pagination-item text-center" *ngIf="showTextPages" translate="gallery.previous" (click)="changePage(currentPageNumber - 1, $event)" [routerLink]="disableSEO ? null : baseUrl" [queryParams]="disableSEO ? null : {page: currentPageNumber}"></a>
    <a class="pagination-item text-center" (click)="changePage(currentPageNumber - 1, $event)" [routerLink]="disableSEO ? null : baseUrl" [queryParams]="disableSEO ? null : {page: currentPageNumber }">
      {{currentPageNumber}}
    </a>
  </ng-container>
  <a class="pagination-item text-center selected">
    {{currentPageNumber + 1}}
  </a>
  <ng-container *ngIf="currentPageNumber < totalPages - 1">
    <a class="pagination-item text-center" (click)="changePage(currentPageNumber + 1, $event)" [routerLink]="disableSEO ? null : baseUrl" [queryParams]="disableSEO ? null : {page: currentPageNumber + 2}">
      {{currentPageNumber + 2}}
    </a>
    <a class="pagination-item text-center" *ngIf="showTextPages" translate="gallery.next" (click)="changePage(currentPageNumber + 1, $event)" [routerLink]="disableSEO ? null : baseUrl" [queryParams]="disableSEO ? null : {page: currentPageNumber + 2}"></a>
    <a class="pagination-item text-center" (click)="changePage(totalPages - 1, $event)" [routerLink]="disableSEO ? null : baseUrl" [queryParams]="disableSEO ? null : {page: totalPages}">
      >>
    </a>
  </ng-container>
</div>
